 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER301YOUWIN from '@/components/0_chapter301youwin'
 import A_CHAPTER302COMEWITHMETOAPLACE from '@/components/1_chapter302comewithmetoaplace'
 import A_CHAPTER303AVIEWOFHERBACK from '@/components/2_chapter303aviewofherback'
 import A_CHAPTER304HEWASBORNINTHEMIDSTOFBLISS from '@/components/3_chapter304hewasborninthemidstofbliss'
 import A_CHAPTER305DONTSAYNEVEREASILY from '@/components/4_chapter305dontsaynevereasily'
 import A_CHAPTER306NANNYFICKFORONENIGHTBENOTSOCHEAP from '@/components/5_chapter306nannyfickforonenightbenotsocheap'
 import A_CHAPTER307TWOTIGERS from '@/components/6_chapter307twotigers'
 import A_CHAPTER308FOURMENATABLEOFMAHJONG from '@/components/7_chapter308fourmenatableofmahjong'
 import A_CHAPTER309YOUAREHISRIGHTFULWIFE from '@/components/8_chapter309youarehisrightfulwife'
 import A_CHAPTER310ILLEGITIMATECHILD from '@/components/9_chapter310illegitimatechild'
 import A0_CHAPTER311REUNION from '@/components/10_chapter311reunion'
 import A1_CHAPTER312DONTDRINKFORFEAROFPOISONING from '@/components/11_chapter312dontdrinkforfearofpoisoning'
 import A2_CHAPTER313BECAUSEILOVEYOU from '@/components/12_chapter313becauseiloveyou'
 import A3_CHAPTER314CANTCHASEAWOMAN from '@/components/13_chapter314cantchaseawoman'
 import A4_CHAPTER315AREYOUITCHY from '@/components/14_chapter315areyouitchy'
 import A5_CHAPTER316TOLIVEHAPPILYTOGETHER from '@/components/15_chapter316tolivehappilytogether'
 import A6_CHAPTER317YOUCANONLYHAVEMEINYOUREYES from '@/components/16_chapter317youcanonlyhavemeinyoureyes'
 import A7_CHAPTER318EVERYTHINGISUPTOYOU from '@/components/17_chapter318everythingisuptoyou'
 import A8_CHAPTER319ITSALLUPTOFATE from '@/components/18_chapter319itsalluptofate'
 import A9_CHAPTER320YOURSAFETYISMOREIMPORTANT from '@/components/19_chapter320yoursafetyismoreimportant'
 import A0_CHAPTER321HESMYBROTHER from '@/components/20_chapter321hesmybrother'
 import A1_CHAPTER322YOUARETHEONETHATPEOPLETALKABOUTWHENTHEYARESTUPID from '@/components/21_chapter322youaretheonethatpeopletalkaboutwhentheyarestupid'
 import A2_CHAPTER323DONTBEAFRAIDIMOUTSIDE from '@/components/22_chapter323dontbeafraidimoutside'
 import A3_CHAPTER324IMISSYOU from '@/components/23_chapter324imissyou'
 import A4_CHAPTER325IALSOWANTTOLIVEHERE from '@/components/24_chapter325ialsowanttolivehere'
 import A5_CHAPTER326IFWEMISSEACHOTHERWEMISSEACHOTHER from '@/components/25_chapter326ifwemisseachotherwemisseachother'
 import A6_CHAPTER327NANAISALREADYPREGNANTWITHXISCHILD from '@/components/26_chapter327nanaisalreadypregnantwithxischild'
 import A7_CHAPTER328YOUACTUALLYCALLEDTHEPOLICE from '@/components/27_chapter328youactuallycalledthepolice'
 import A8_CHAPTER329HESMYSONSFATHERBIBI from '@/components/28_chapter329hesmysonsfatherbibi'
 import A9_CHAPTER330THEMOREMYMOTHERINLAWSAWHERSONINLAWTHEMORESHELIKEDHIM from '@/components/29_chapter330themoremymotherinlawsawhersoninlawthemoreshelikedhim'
 import A0_CHAPTER331STILLANGRY from '@/components/30_chapter331stillangry'
 import A1_CHAPTER332IMABADWOMAN from '@/components/31_chapter332imabadwoman'
 import A2_CHAPTER333IMGOINGTOTAMEALITTLEWILDHORSE from '@/components/32_chapter333imgoingtotamealittlewildhorse'
 import A3_CHAPTER334THERESULTOFTHEAPPRAISALBECOMEOUT from '@/components/33_chapter334theresultoftheappraisalbecomeout'
 import A4_CHAPTER335THEREISSURPRISE from '@/components/34_chapter335thereissurprise'
 import A5_CHAPTER336IMTRYINGTOGETYOUPREGNANT from '@/components/35_chapter336imtryingtogetyoupregnant'
 import A6_CHAPTER337DIDYOUFEELGOODWATCHINGTHEMTHROWDOGFOODAROUND from '@/components/36_chapter337didyoufeelgoodwatchingthemthrowdogfoodaround'
 import A7_CHAPTER338AREYOUSUREYOUWANTTODRINKWITHME from '@/components/37_chapter338areyousureyouwanttodrinkwithme'
 import A8_CHAPTER339WHYDIDYOURUNINTOMYHEART from '@/components/38_chapter339whydidyourunintomyheart'
 import A9_CHAPTER340INEVITABLYMANYPEOPLEHAVEALONGNIGHTSSLEEP from '@/components/39_chapter340inevitablymanypeoplehavealongnightssleep'
 import A0_CHAPTER341CANTYOUBEMOREGENTLE from '@/components/40_chapter341cantyoubemoregentle'
 import A1_CHAPTER342STALKINGSURVEILLANCE from '@/components/41_chapter342stalkingsurveillance'
 import A2_CHAPTER343KEEFERSLIFE from '@/components/42_chapter343keeferslife'
 import A3_CHAPTER344YOUDBETTERSTAYINTHISPOSITIONALLTHETIME from '@/components/43_chapter344youdbetterstayinthispositionallthetime'
 import A4_CHAPTER345AREYOUPREGNANT from '@/components/44_chapter345areyoupregnant'
 import A5_CHAPTER346MARRYMEBEMYWIFE from '@/components/45_chapter346marrymebemywife'
 import A6_CHAPTER347YOUAREADEMON from '@/components/46_chapter347youareademon'
 import A7_CHAPTER348DOWHATYOUHAVETODO from '@/components/47_chapter348dowhatyouhavetodo'
 import A8_CHAPTER349IFYOUDONOTCHERISHITLETITGO from '@/components/48_chapter349ifyoudonotcherishitletitgo'
 import A9_CHAPTER350ANOTHERONEAPPEARED from '@/components/49_chapter350anotheroneappeared'
 import A0_CHAPTER351THISMUSTBEACOMPOSITEPICTURE from '@/components/50_chapter351thismustbeacompositepicture'
 import A1_CHAPTER352BIGBROTHERSARMWILLALWAYSLETYOULEANON from '@/components/51_chapter352bigbrothersarmwillalwaysletyouleanon'
 import A2_CHAPTER353IWONTLETANYTHINGHAPPENTOYOU from '@/components/52_chapter353iwontletanythinghappentoyou'
 import A3_CHAPTER354ITSALLYOURFAULT from '@/components/53_chapter354itsallyourfault'
 import A4_CHAPTER355YOUWANTMETOWASHITFORYOU from '@/components/54_chapter355youwantmetowashitforyou'
 import A5_CHAPTER356IMGOINGTOUSEMYULTIMATEMOVE from '@/components/55_chapter356imgoingtousemyultimatemove'
 import A6_CHAPTER357MYAUNTISHERE from '@/components/56_chapter357myauntishere'
 import A7_CHAPTER358LIJUNXIYOUVEHADENOUGH from '@/components/57_chapter358lijunxiyouvehadenough'
 import A8_CHAPTER359THEEVILWOMANISONHIM from '@/components/58_chapter359theevilwomanisonhim'
 import A9_CHAPTER360BECAUSEILOVEYOU from '@/components/59_chapter360becauseiloveyou'
 import A0_CHAPTER361SHAMEONYOU from '@/components/60_chapter361shameonyou'
 import A1_CHAPTER362AREYOUNOTGOINGTOSAVEME from '@/components/61_chapter362areyounotgoingtosaveme'
 import A2_CHAPTER363AREYOUREALLYGOINGTOPLAYMETODEATH from '@/components/62_chapter363areyoureallygoingtoplaymetodeath'
 import A3_CHAPTER364IHAVEAVIDEO from '@/components/63_chapter364ihaveavideo'
 import A4_CHAPTER365YOUKNOWTHEGIFTIWANT from '@/components/64_chapter365youknowthegiftiwant'
 import A5_CHAPTER366LIJUNXIYOUAREREALLYDESPICABLE from '@/components/65_chapter366lijunxiyouarereallydespicable'
 import A6_CHAPTER367THEPEOPLEINTHEVICINITYARETHEONESWHOBRINGDISASTERUPONTHEMSELVES from '@/components/66_chapter367thepeopleinthevicinityaretheoneswhobringdisasteruponthemselves'
 import A7_CHAPTER368DIDYOUGETABURNINYOURHEAD from '@/components/67_chapter368didyougetaburninyourhead'
 import A8_CHAPTER369ASLONGASYOUREOKAYTHATSFINE from '@/components/68_chapter369aslongasyoureokaythatsfine'
 import A9_CHAPTER370IAMLIJUNXINOTHINGHARDTOCOMEBY from '@/components/69_chapter370iamlijunxinothinghardtocomeby'
 import A0_CHAPTER371ILLCARRYYOUONMYBACK from '@/components/70_chapter371illcarryyouonmyback'
 import A1_CHAPTER372IDONTCARE from '@/components/71_chapter372idontcare'
 import A2_CHAPTER373DONTBECHEAPANDBEAGOODBOY from '@/components/72_chapter373dontbecheapandbeagoodboy'
 import A3_CHAPTER374MONSTERSHOWYOUREALLWRONG from '@/components/73_chapter374monstershowyoureallwrong'
 import A4_CHAPTER375STUCKINTOSHOWFIELDWITHOUTREGRET from '@/components/74_chapter375stuckintoshowfieldwithoutregret'
 import A5_CHAPTER376TOOHEARTPIERCING from '@/components/75_chapter376tooheartpiercing'
 import A6_CHAPTER377MENOPAUSEOLDMAN from '@/components/76_chapter377menopauseoldman'
 import A7_CHAPTER378SOONTOBESONINLAW from '@/components/77_chapter378soontobesoninlaw'
 import A8_CHAPTER379ISTHATTOPROPOSETOME from '@/components/78_chapter379isthattoproposetome'
 import A9_CHAPTER380YOUDONTHAVETOPUTINSOMUCHEFFORTDOYOU from '@/components/79_chapter380youdonthavetoputinsomucheffortdoyou'
 import A0_CHAPTER381ASYOUWISHBROTHERINLAW from '@/components/80_chapter381asyouwishbrotherinlaw'
 import A1_CHAPTER382LOVEISCONSISTENT from '@/components/81_chapter382loveisconsistent'
 import A2_CHAPTER383COULDHEBETRYINGTOSELLMEOUT from '@/components/82_chapter383couldhebetryingtosellmeout'
 import A3_CHAPTER384IDIDNTEXPECTYOUTOBESODESPICABLE from '@/components/83_chapter384ididntexpectyoutobesodespicable'
 import A4_CHAPTER385YOUDBETTERKEEPYOURPROMISE from '@/components/84_chapter385youdbetterkeepyourpromise'
 import A5_CHAPTER386TWOFLOWERSTWOMEN from '@/components/85_chapter386twoflowerstwomen'
 import A6_CHAPTER387WHICHDOYOULIKEBETTER from '@/components/86_chapter387whichdoyoulikebetter'
 import A7_CHAPTER388SOMETHINGSHAPPENED from '@/components/87_chapter388somethingshappened'
 import A8_CHAPTER389IAMTHEFATHEROFTHECHILD from '@/components/88_chapter389iamthefatherofthechild'
 import A9_CHAPTER390BEGOODANDDONTBESAD from '@/components/89_chapter390begoodanddontbesad'
 import A0_CHAPTER391AHITHURTS from '@/components/90_chapter391ahithurts'
 import A1_CHAPTER392FOOLISHGIRLITSNOTLIKEIMBLAMINGYOU from '@/components/91_chapter392foolishgirlitsnotlikeimblamingyou'
 import A2_CHAPTER393HEISACTINGANDYOUHAVEBEENDUPEDBYHIM from '@/components/92_chapter393heisactingandyouhavebeendupedbyhim'
 import A3_CHAPTER394ALIENATIONANDINTIMACY from '@/components/93_chapter394alienationandintimacy'
 import A4_CHAPTER395YOUDIDNTDIE from '@/components/94_chapter395youdidntdie'
 import A5_CHAPTER396AREYOUGOINGTOFORCEAMARRIAGE from '@/components/95_chapter396areyougoingtoforceamarriage'
 import A6_CHAPTER397AREYOUSTAYINGTONIGHT from '@/components/96_chapter397areyoustayingtonight'
 import A7_CHAPTER398WHATELSEISTHERETHATIHAVENTSEENBEFORE from '@/components/97_chapter398whatelseistherethatihaventseenbefore'
 import A8_CHAPTER399YOUDONTHAVETOWASHTHAT from '@/components/98_chapter399youdonthavetowashthat'
 import A9_CHAPTER400HEWASJUSTTRYINGTOSCAREYOU from '@/components/99_chapter400hewasjusttryingtoscareyou'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter301youwin",
 			"name" : "0_chapter301youwin",
 			"component" : A_CHAPTER301YOUWIN
 		},
 		{
 			"path" : "/1_chapter302comewithmetoaplace",
 			"name" : "1_chapter302comewithmetoaplace",
 			"component" : A_CHAPTER302COMEWITHMETOAPLACE
 		},
 		{
 			"path" : "/2_chapter303aviewofherback",
 			"name" : "2_chapter303aviewofherback",
 			"component" : A_CHAPTER303AVIEWOFHERBACK
 		},
 		{
 			"path" : "/3_chapter304hewasborninthemidstofbliss",
 			"name" : "3_chapter304hewasborninthemidstofbliss",
 			"component" : A_CHAPTER304HEWASBORNINTHEMIDSTOFBLISS
 		},
 		{
 			"path" : "/4_chapter305dontsaynevereasily",
 			"name" : "4_chapter305dontsaynevereasily",
 			"component" : A_CHAPTER305DONTSAYNEVEREASILY
 		},
 		{
 			"path" : "/5_chapter306nannyfickforonenightbenotsocheap",
 			"name" : "5_chapter306nannyfickforonenightbenotsocheap",
 			"component" : A_CHAPTER306NANNYFICKFORONENIGHTBENOTSOCHEAP
 		},
 		{
 			"path" : "/6_chapter307twotigers",
 			"name" : "6_chapter307twotigers",
 			"component" : A_CHAPTER307TWOTIGERS
 		},
 		{
 			"path" : "/7_chapter308fourmenatableofmahjong",
 			"name" : "7_chapter308fourmenatableofmahjong",
 			"component" : A_CHAPTER308FOURMENATABLEOFMAHJONG
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js